import React from 'react';
import { JobSource, FormErrors } from '../types';

interface CompanyInfoSectionProps {
  formData: JobSource;
  setFormData: React.Dispatch<React.SetStateAction<JobSource>>;
  errors: FormErrors;
}

const CompanyInfoSection: React.FC<CompanyInfoSectionProps> = ({
  formData,
  setFormData,
  errors,
}) => {
  const handleChange = (field: keyof JobSource, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="tab-pane active">
      <div className="form-group mb-3">
        <label htmlFor="established_date" className="form-label fw-semibold">
          設立日
        </label>
        <input
          type="text"
          id="established_date"
          className={`form-control ${errors.established_date ? 'is-invalid' : ''}`}
          value={formData.established_date || ''}
          onChange={(e) => handleChange('established_date', e.target.value)}
          placeholder="例: 2010年4月1日"
        />
        {errors.established_date && (
          <div className="invalid-feedback">{errors.established_date.join(', ')}</div>
        )}
      </div>

      <div className="form-group mb-3">
        <label htmlFor="capital" className="form-label fw-semibold">
          資本金
        </label>
        <input
          type="text"
          id="capital"
          className={`form-control ${errors.capital ? 'is-invalid' : ''}`}
          value={formData.capital || ''}
          onChange={(e) => handleChange('capital', e.target.value)}
          placeholder="例: 1000万円"
        />
        {errors.capital && (
          <div className="invalid-feedback">{errors.capital.join(', ')}</div>
        )}
      </div>

      <div className="form-group mb-3">
        <label htmlFor="representative_name" className="form-label fw-semibold">
          代表者名
        </label>
        <input
          type="text"
          id="representative_name"
          className={`form-control ${errors.representative_name ? 'is-invalid' : ''}`}
          value={formData.representative_name || ''}
          onChange={(e) => handleChange('representative_name', e.target.value)}
          placeholder="例: 山田太郎"
        />
        {errors.representative_name && (
          <div className="invalid-feedback">{errors.representative_name.join(', ')}</div>
        )}
      </div>

      <div className="form-group mb-3">
        <label htmlFor="employee_count" className="form-label fw-semibold">
          従業員数
        </label>
        <input
          type="text"
          id="employee_count"
          className={`form-control ${errors.employee_count ? 'is-invalid' : ''}`}
          value={formData.employee_count || ''}
          onChange={(e) => handleChange('employee_count', e.target.value)}
          placeholder="例: 100名"
        />
        {errors.employee_count && (
          <div className="invalid-feedback">{errors.employee_count.join(', ')}</div>
        )}
      </div>

      <div className="form-group mb-3">
        <label htmlFor="corporate_name" className="form-label fw-semibold">
          法人名
        </label>
        <input
          type="text"
          id="corporate_name"
          className={`form-control ${errors.corporate_name ? 'is-invalid' : ''}`}
          value={formData.corporate_name || ''}
          onChange={(e) => handleChange('corporate_name', e.target.value)}
          placeholder="例: 株式会社テスト"
        />
        {errors.corporate_name && (
          <div className="invalid-feedback">{errors.corporate_name.join(', ')}</div>
        )}
      </div>
    </div>
  );
};

export default CompanyInfoSection;



